import React from "react";

// Dependencies
import ProdigioTheme from "prodigio-themes";

// Assets
import logo from "static/proraiz/logo.svg";
import logoSmall from "static/proraiz/logoSmall.svg";
import logoWhite from "static/proraiz/logoWhite.svg";

// Navigation icons
import SimuladoIcon from "prodigio-icons/web/outlined/Simulado";
import CalendarIcon from "prodigio-icons/web/outlined/Calendar";
import ProjectIcon from "prodigio-icons/web/outlined/Project";
import PreviousExamsIcon from "prodigio-icons/web/outlined/ProvasAnteriores";
import StudyPlanIcon from "prodigio-icons/web/outlined/StudyPlan";
import SubjectIcon from "prodigio-icons/web/outlined/Subject";
import FileIcon from "prodigio-icons/web/outlined/Apoio";
import CustomExerciseListIcon from "prodigio-icons/web/outlined/CustomExerciseList";
import QRCode from "prodigio-icons/web/outlined/QrCode";
import TemplateSheet from "prodigio-icons/web/outlined/TemplateSheet";

// Helpers
import { INavigation } from "interfaces/INavigation";
import { generateThemeData } from "helpers/generate-theme-data";

export const prodigioTheme = new ProdigioTheme({
    project: {
        appUrl: "proraiz.prodigioeducacao.com",
        brand: "proraiz",
        name: "ProRaiz",
        slug: "proraiz",
        url: "proraiz.prodigioeducacao.com",
        logo,
        logoSmall,
        logoWhite
    },
    mainColors: {
        base: "#83899E",
        brand: "#24388C",
        secondary: "#F44C00"
    }
});

export const theme = generateThemeData(prodigioTheme, {
    brand: {
        100: "#4AC8F4",
        200: "#0099FF",
        300: "#24388C",
        400: "#1D2E70",
        500: "#162152"
    },
    secondary: {
        100: "#FE9E32",
        200: "#EE781E",
        300: "#F44C00",
        400: "#D14200",
        500: "#A13300"
    }
});

export const menuColors: any = {};

export const navigation: INavigation[] = [
    {
        name: "Agenda de aulas",
        url: "/app/plano-de-estudos",
        icon: <CalendarIcon width="22" height="22" />
    },
    {
        name: "Plano de estudos",
        url: "/app/meu-plano-de-estudos",
        icon: <StudyPlanIcon width="22" height="22" />
    },
    {
        name: "Matérias",
        url: "/app/materias",
        icon: <SubjectIcon width="22" height="22" />
    },
    {
        name: "Atividades",
        url: "/app/atividades",
        icon: <TemplateSheet width="22" height="22" />
    },
    {
        name: "Simulados",
        url: "/app/simulados",
        icon: <SimuladoIcon width="22" height="22" />
    },
    {
        name: "Banco de questões",
        url: "/app/banco-de-questoes",
        icon: <CustomExerciseListIcon width="22" height="22" />
    },
    {
        name: "Projetos",
        url: "/app/projetos",
        icon: <ProjectIcon width="22" height="22" />
    },
    {
        name: "Provas anteriores",
        url: "/app/provas-anteriores",
        icon: <PreviousExamsIcon width="22" height="22" />
    },
    {
        name: "Arquivos",
        url: "/app/arquivos",
        icon: <FileIcon width="22" height="22" />
    },
    {
        name: "QRCode",
        url: "/app/qr-code",
        icon: <QRCode width="22" height="22" />
    }
];
